import React from "react";
import Modal from "./Modal";
import UploadCsvForm from "./UploadCsvForm";
import LinkShopify from "./LinkShopify";
import { Box, Text } from "grommet";
import LinkQuickbooks from "./LinkQuickbooks";

const ImportCustomerModal = ({ onClose, importMethod, user, onImportStarted }) => {
    //need custom function specifically for shopify
    const onLinked = () => {
        onImportStarted && onImportStarted();
        onClose();
    }

    return (
        <Modal
            onClose={onClose}
            title={`Import customers`}
            hideDeepLink={true}
            hideCancelBtn={true}
        >
            {importMethod === "CSV" && <UploadCsvForm onClose={onLinked} />}
            {importMethod === "Shopify" && (
                <Box gap="xsmall" width="medium" pad={{top: 'xsmall'}}>
                    <Text>To begin, connect your Shopify store with Streamlined.</Text>
                    <LinkShopify
                        userId={user?.id}
                        onLinked={onLinked}
                        ctaColor="status-ok"
                        buttonWrapperProps={{
                            pad: {vertical: 'small'},
                        }}
                    />
                </Box>
            )}
            {importMethod === "Quickbooks" && (
                <Box gap="xsmall" width="medium" pad={{top: 'xsmall'}}>
                    <Text>To begin, connect your QuickBooks account with Streamlined.</Text>
                    <LinkQuickbooks
                        userId={user?.id}
                        onLinked={onLinked}
                        importCustomers={true}
                    />
                </Box>
            )}
        </Modal>
    );
};

export default ImportCustomerModal;
